$(document).ready(function() {
  function toggleFAQ() {
    const isMobile = $(window).width() < 768;
    $('.block__faq_list_block .block__faq_data_header > div').toggle(!isMobile);
    $('.block__faq_list_block .answer-wrapper').toggle(!isMobile);
    $('.block__faq_list_block').removeClass('active');

    if (isMobile) {
      $('.block__faq_list_block .block__faq_type_heading').off('click').on('click', function() {
        const $parentBlock = $(this).closest('.block__faq_list_block');
        const $headerDiv = $(this).closest('.block__faq_data_header').find('> div');
        const $slideDiv = $parentBlock.find('.answer-wrapper');

        if (!$headerDiv.is(':animated')) {
          $headerDiv.slideToggle(() => $parentBlock.toggleClass('active', $headerDiv.is(':visible')));
          $slideDiv.slideToggle();

          $('.block__faq_list_block').not($parentBlock).find('.block__faq_data_header > div, .answer-wrapper').slideUp();
        }
      });
    }
  }

  toggleFAQ();

  function toggleFaqBlock(targetSectionId) {
    if (window.innerWidth <= 767) {
      $('.block__faq_list_block').removeClass('active').find('.inner-data, .answer-wrapper').slideUp();
      const $matchingBlock = $(`.block__faq_list_block[id="${targetSectionId}"]`);
      if ($matchingBlock.length) {
        $matchingBlock.addClass('active').find('.inner-data, .answer-wrapper').slideDown();
      }
    }
  }

  function scrollToSection(targetSectionId) {
    if (window.innerWidth <= 767) {
      const targetElement = document.getElementById(targetSectionId);
      if (targetElement) {
        window.scrollTo({ top: targetElement.getBoundingClientRect().top + window.pageYOffset - 70, behavior: 'smooth' });
      }
    }
  }

  const hash = window.location.hash.substring(1);
  if (hash) {
    toggleFaqBlock(hash);
    setTimeout(() => scrollToSection(hash), 500);
  }

  $('.footer_menu_link, a.menu-drawer__menu-item').on('click', function(event) {
    const href = this.getAttribute('href');
    const isHashLink = href.includes('#');

    if (isHashLink && window.location.pathname === new URL(href).pathname) {
      event.preventDefault();
      const targetSectionId = href.split('#')[1];
      toggleFaqBlock(targetSectionId);
      history.pushState(null, null, `#${targetSectionId}`);
      setTimeout(() => scrollToSection(targetSectionId), 500);
    } else {
      window.location.href = href;
    }

    if ($(this).hasClass('menu-drawer__menu-item')) {
      $('.header__icon--menu').click();
    }
  });
});
